import { LuCirclePlus, LuFileText, LuHistory, LuMail, LuSearch, LuServer } from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('email', '/settings/emails', null, [
    ['direction', 'email.direction', LuMail],
    ['add', 'email.add', LuCirclePlus, opt],
    ['list', 'email.list', LuServer, { placement: 'top', ...opt }],
  ]),
  tour('email_templates', '/email/templates', null, [
    ['list', 'email_templates.list', LuFileText, { placement: 'top' }],
    ['search', 'email_templates.search', LuSearch],
    ['create', 'email_templates.create', LuCirclePlus],
  ]),
  tour('email_logs', '/email-logs', null, [
    ['log', 'email_logs.log', LuHistory, { placement: 'top' }],
    ['search', 'email_logs.search', LuSearch],
  ]),
];

export default tours;
